/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { mediaTypeControllerCreate } from '../fn/file-manager-tipologie/media-type-controller-create';
import { MediaTypeControllerCreate$Params } from '../fn/file-manager-tipologie/media-type-controller-create';
import { mediaTypeControllerFindAll } from '../fn/file-manager-tipologie/media-type-controller-find-all';
import { MediaTypeControllerFindAll$Params } from '../fn/file-manager-tipologie/media-type-controller-find-all';
import { mediaTypeControllerFindOne } from '../fn/file-manager-tipologie/media-type-controller-find-one';
import { MediaTypeControllerFindOne$Params } from '../fn/file-manager-tipologie/media-type-controller-find-one';
import { mediaTypeControllerRemove } from '../fn/file-manager-tipologie/media-type-controller-remove';
import { MediaTypeControllerRemove$Params } from '../fn/file-manager-tipologie/media-type-controller-remove';
import { mediaTypeControllerUpdate } from '../fn/file-manager-tipologie/media-type-controller-update';
import { MediaTypeControllerUpdate$Params } from '../fn/file-manager-tipologie/media-type-controller-update';
import { MediaTypeItem } from '../models/media-type-item';
import { MediaTypeResponse } from '../models/media-type-response';

@Injectable({ providedIn: 'root' })
export class FileManagerTipologieService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mediaTypeControllerFindAll()` */
  static readonly MediaTypeControllerFindAllPath = '/file-manager/types';

  /**
   * Restituisce l'elenco delle tipologie.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaTypeControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaTypeControllerFindAll$Response(params?: MediaTypeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeResponse;
}>> {
    const obs = mediaTypeControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco delle tipologie.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaTypeControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaTypeControllerFindAll(params?: MediaTypeControllerFindAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaTypeResponse;
}> {
    const resp = this.mediaTypeControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeResponse;
}>): BaseResponse & {
'data'?: MediaTypeResponse;
} => r.body)
    );
  }

  /** Path part for operation `mediaTypeControllerCreate()` */
  static readonly MediaTypeControllerCreatePath = '/file-manager/types';

  /**
   * Crea una tipologia di file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaTypeControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaTypeControllerCreate$Response(params: MediaTypeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>> {
    const obs = mediaTypeControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea una tipologia di file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaTypeControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaTypeControllerCreate(params: MediaTypeControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaTypeItem;
}> {
    const resp = this.mediaTypeControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>): BaseResponse & {
'data'?: MediaTypeItem;
} => r.body)
    );
  }

  /** Path part for operation `mediaTypeControllerFindOne()` */
  static readonly MediaTypeControllerFindOnePath = '/file-manager/types/{id}';

  /**
   * Restituisce una tipologia.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaTypeControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaTypeControllerFindOne$Response(params: MediaTypeControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>> {
    const obs = mediaTypeControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce una tipologia.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaTypeControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaTypeControllerFindOne(params: MediaTypeControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaTypeItem;
}> {
    const resp = this.mediaTypeControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>): BaseResponse & {
'data'?: MediaTypeItem;
} => r.body)
    );
  }

  /** Path part for operation `mediaTypeControllerRemove()` */
  static readonly MediaTypeControllerRemovePath = '/file-manager/types/{id}';

  /**
   * Disattiva una tipologia (soft delete).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaTypeControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaTypeControllerRemove$Response(params: MediaTypeControllerRemove$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>> {
    const obs = mediaTypeControllerRemove(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Disattiva una tipologia (soft delete).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaTypeControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaTypeControllerRemove(params: MediaTypeControllerRemove$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaTypeItem;
}> {
    const resp = this.mediaTypeControllerRemove$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>): BaseResponse & {
'data'?: MediaTypeItem;
} => r.body)
    );
  }

  /** Path part for operation `mediaTypeControllerUpdate()` */
  static readonly MediaTypeControllerUpdatePath = '/file-manager/types/{id}';

  /**
   * Aggiorna una tipologia.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaTypeControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaTypeControllerUpdate$Response(params: MediaTypeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>> {
    const obs = mediaTypeControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Aggiorna una tipologia.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaTypeControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mediaTypeControllerUpdate(params: MediaTypeControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaTypeItem;
}> {
    const resp = this.mediaTypeControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>): BaseResponse & {
'data'?: MediaTypeItem;
} => r.body)
    );
  }

}
